import Controller from '@ember/controller';
import { type Registry as Services, service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type { GeneralDefaultsModel } from 'lumen/routes/hotel/settings/my-property/general-defaults';
import type { ControllerWithUnsavedChanges } from 'lumen/utils/unsaved-changes-transition-handlers';

export default class HotelSettingsMyPropertyGeneralDefaultsController
  extends Controller
  implements ControllerWithUnsavedChanges
{
  declare model: GeneralDefaultsModel;
  @service declare alerting: Services['alerting'];
  @service declare intl: IntlService;

  get hasUnsavedChanges(): boolean {
    return (
      this.model.requestChannelDistributionTask.last?.value
        ?.hasDirtyAttributes ?? false
    );
  }

  discardChanges(): void {
    this.model.requestChannelDistributionTask.last?.value?.rollbackAttributes();
  }

  async showDiscardChangesAlert(): Promise<boolean> {
    return this.alerting.showConfirmWarningAlert({
      dangerMode: true,
      title: this.intl.t('general.unsaved_changes.title'),
      text: this.intl.t('settings.my_hotel.leave_page_alert.description'),
      buttons: {
        cancel: {
          text: this.intl.t('settings.my_hotel.leave_page_alert.cta.cancel'),
        },
        confirm: {
          text: this.intl.t('settings.my_hotel.leave_page_alert.cta.confirm'),
        },
      },
    });
  }
}
